import './App.css';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from 'react-cookie';
import './Main.css';
import Background from './Background';
import { useState, useEffect } from 'react';
import { useParams, Link } from "react-router-dom";

function Transaction() {
    const [cookies, setCookie] = useCookies(['user']);
    const [transaction, setTransaction] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('details');
    const { id } = useParams();

    const getTransaction = () => {
        if (!id) return;
        
        setIsLoading(true);
        fetch(`https://api.connecker.com/api/transactions?id=${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => {
            setIsLoading(false);
            if (!res.ok) {
                throw Error('Could not fetch');
            }
            return res.json();
        }).then(data => {
            setIsLoading(false);
            if (data.success && data.data && data.data.data && data.data.data.length > 0) {
                setTransaction(data.data.data[0]);
            } else {
                setTransaction(null);
            }
        }).catch(error => {
            setIsLoading(false);
            console.error('Error fetching transaction:', error);
            setTransaction(null);
        });
    }

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: '2-digit'
        });
    }

    const formatDateTime = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    }

    const getStatusBadge = (status) => {
        let backgroundColor, textColor;
        switch (status) {
            case 'completed':
            case 'success':
                backgroundColor = '#28a745';
                textColor = 'white';
                break;
            case 'pending':
                backgroundColor = '#ffc107';
                textColor = '#212529';
                break;
            case 'initiated':
                backgroundColor = '#17a2b8';
                textColor = 'white';
                break;
            case 'failed':
            case 'cancelled':
                backgroundColor = '#dc3545';
                textColor = 'white';
                break;
            default:
                backgroundColor = '#6c757d';
                textColor = 'white';
        }

        return (
            <span style={{
                padding: "6px 16px",
                backgroundColor: backgroundColor,
                borderRadius: "20px",
                color: textColor,
                fontSize: "12px",
                fontWeight: "600",
                display: "inline-block",
                textAlign: "center",
                textTransform: "uppercase"
            }}>
                {status}
            </span>
        );
    }

    useEffect(() => {
        getTransaction();
    }, [id]);

    if (isLoading) {
        return (
            <div className="content">
                <div className="row pb-2">
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                        <Sidebar></Sidebar>
                    </div>
                    <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10">
                        <Background></Background>
                        <div style={{ textAlign: "center", padding: "100px 0", color: "white" }}>
                            <h4>Loading Transaction...</h4>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    if (!transaction) {
        return (
            <div className="content">
                <div className="row pb-2">
                    <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                        <Sidebar></Sidebar>
                    </div>
                    <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10">
                        <Background></Background>
                        <div style={{ textAlign: "center", padding: "100px 0", color: "white" }}>
                            <h4>Transaction Not Found</h4>
                            <Link to="/transactions" style={{ color: "#FF4500" }}>← Back to Transaction List</Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="content">
            <div className="row pb-2">
                <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10" style={{ paddingLeft: "40px" }}>
                    <Background></Background>
                    
                    {/* Header */}
                    <h4 className="heading" style={{ color: "white", marginTop: "50px" }}>Transaction Invoice</h4>
                    
                    {/* Invoice Card */}
                    <div className="card" style={{ borderColor: "white", borderRadius: "8px", overflow: "hidden" }}>
                        
                        {/* Orange Header */}
                        <div style={{ 
                            backgroundColor: "#FF4500", 
                            padding: "20px 30px", 
                            color: "white" 
                        }}>
                            <div className="row align-items-center">
                                <div className="col-md-6">
                                    <h5 style={{ margin: 0, fontWeight: "600" }}>
                                        <span style={{ color: "#FFE4D6" }}>Single</span> Invoice
                                    </h5>
                                </div>
                                <div className="col-md-6 text-end">
                                    <Link 
                                        to="/transactions" 
                                        style={{ 
                                            color: "white", 
                                            textDecoration: "none",
                                            fontSize: "14px"
                                        }}
                                    >
                                        ← Back to List
                                    </Link>
                                </div>
                            </div>
                        </div>

                        {/* Invoice Details Header */}
                        <div style={{ padding: "25px 30px 15px", borderBottom: "1px solid #eee" }}>
                            <h6 style={{ margin: 0, color: "#333", fontSize: "18px" }}>
                                Invoice Details: <span style={{ color: "#FF4500" }}>#{transaction.ref_command}</span>
                            </h6>
                        </div>

                        {/* Tab Navigation */}
                        <div style={{ padding: "0 30px", borderBottom: "1px solid #eee" }}>
                            <div className="d-flex">
                                <button 
                                    onClick={() => setActiveTab('details')}
                                    style={{
                                        padding: "12px 24px",
                                        border: "none",
                                        backgroundColor: activeTab === 'details' ? "#FF4500" : "transparent",
                                        color: activeTab === 'details' ? "white" : "#666",
                                        borderRadius: activeTab === 'details' ? "20px 20px 0 0" : "0",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        cursor: "pointer",
                                        marginRight: "10px"
                                    }}
                                >
                                    Details
                                </button>
                                <button 
                                    onClick={() => setActiveTab('history')}
                                    style={{
                                        padding: "12px 24px",
                                        border: "1px solid #ddd",
                                        backgroundColor: activeTab === 'history' ? "#FF4500" : "transparent",
                                        color: activeTab === 'history' ? "white" : "#666",
                                        borderRadius: activeTab === 'history' ? "20px 20px 0 0" : "20px",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        cursor: "pointer"
                                    }}
                                >
                                    History
                                </button>
                            </div>
                        </div>

                        {/* Content */}
                        <div style={{ padding: "30px" }}>
                            {activeTab === 'details' ? (
                                <>
                                    {/* Customer & Order Info */}
                                    <div className="row mb-4">
                                        <div className="col-md-8">
                                            <h6 style={{ color: "#333", fontWeight: "600", marginBottom: "15px" }}>
                                                Customer Information
                                            </h6>
                                            <div style={{ color: "#666", lineHeight: "1.6" }}>
                                                <div style={{ fontWeight: "600", color: "#333", fontSize: "16px" }}>
                                                    {transaction.user?.middle_name && transaction.user?.middle_name !== "null" ?
                                                        `${transaction.user?.first_name} ${transaction.user?.middle_name} ${transaction.user?.last_name}` :
                                                        `${transaction.user?.first_name || ''} ${transaction.user?.last_name || ''}`
                                                    }
                                                </div>
                                                <div>{transaction.user?.email}</div>
                                                <div>{transaction.user?.mobile}</div>
                                                {transaction.property?.address && (
                                                    <div>{transaction.property?.address}</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-4 text-end">
                                            <div style={{ marginBottom: "10px" }}>
                                                <strong style={{ color: "#333" }}>Transaction Date:</strong> {formatDate(transaction.created_at)}
                                            </div>
                                            <div style={{ marginBottom: "10px" }}>
                                                <strong style={{ color: "#333" }}>Transaction Status:</strong> {getStatusBadge(transaction.status)}
                                            </div>
                                            <div>
                                                <strong style={{ color: "#333" }}>Transaction ID:</strong> #{transaction.id}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Invoice Table */}
                                    <div className="table-responsive">
                                        <table className="table" style={{ marginBottom: "0" }}>
                                            <thead>
                                                <tr style={{ borderTop: "2px solid #ddd", borderBottom: "2px solid #ddd" }}>
                                                    <th style={{ padding: "15px 0", color: "#333", fontWeight: "600", border: "none" }}>#</th>
                                                    <th style={{ padding: "15px 0", color: "#333", fontWeight: "600", border: "none" }}>Item</th>
                                                    <th style={{ padding: "15px 0", color: "#333", fontWeight: "600", border: "none" }}>Description</th>
                                                    <th style={{ padding: "15px 0", color: "#333", fontWeight: "600", border: "none", textAlign: "center" }}>Quantity</th>
                                                    <th style={{ padding: "15px 0", color: "#333", fontWeight: "600", border: "none", textAlign: "center" }}>Unit Cost</th>
                                                    <th style={{ padding: "15px 0", color: "#333", fontWeight: "600", border: "none", textAlign: "right" }}>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style={{ padding: "20px 0", border: "none", color: "#333" }}>01</td>
                                                    <td style={{ padding: "20px 0", border: "none", color: "#333", fontWeight: "500" }}>
                                                        {transaction.item_name}
                                                    </td>
                                                    <td style={{ padding: "20px 0", border: "none", color: "#666" }}>
                                                        Property transaction for {transaction.property?.name || transaction.item_name}
                                                        <br />
                                                        <small style={{ color: "#999" }}>
                                                            Location: {transaction.property?.region}, {transaction.property?.town}
                                                        </small>
                                                    </td>
                                                    <td style={{ padding: "20px 0", border: "none", color: "#333", textAlign: "center" }}>01</td>
                                                    <td style={{ padding: "20px 0", border: "none", color: "#333", textAlign: "center", fontWeight: "600" }}>
                                                        {parseFloat(transaction.amount).toLocaleString()} {transaction.currency}
                                                    </td>
                                                    <td style={{ padding: "20px 0", border: "none", color: "#333", textAlign: "right", fontWeight: "600", fontSize: "16px" }}>
                                                        {parseFloat(transaction.amount).toLocaleString()} {transaction.currency}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Payment Details */}
                                    <div style={{ marginTop: "30px", paddingTop: "20px", borderTop: "1px solid #eee" }}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <h6 style={{ color: "#333", fontWeight: "600", marginBottom: "15px" }}>
                                                    Payment Information
                                                </h6>
                                                <div style={{ color: "#666", lineHeight: "1.6" }}>
                                                    <div><strong>Currency:</strong> {transaction.currency}</div>
                                                    <div><strong>Payment Token:</strong> {transaction.token || 'Not generated'}</div>
                                                    {transaction.payment_url && (
                                                        <div>
                                                            <strong>Payment URL:</strong>{" "}
                                                            <a 
                                                                href={transaction.payment_url} 
                                                                target="_blank" 
                                                                rel="noopener noreferrer"
                                                                style={{ color: "#007bff" }}
                                                            >
                                                                Open Payment
                                                            </a>
                                                        </div>
                                                    )}
                                                    <div><strong>Payment Date:</strong> {formatDateTime(transaction.payment_date)}</div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div style={{ 
                                                    backgroundColor: "#f8f9fa", 
                                                    padding: "20px", 
                                                    borderRadius: "8px",
                                                    textAlign: "right"
                                                }}>
                                                    <div style={{ 
                                                        fontSize: "24px", 
                                                        fontWeight: "600", 
                                                        color: "#333",
                                                        marginBottom: "5px"
                                                    }}>
                                                        {parseFloat(transaction.amount).toLocaleString()} {transaction.currency}
                                                    </div>
                                                    <div style={{ color: "#666", fontSize: "14px" }}>
                                                        Total Amount
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                // History Tab
                                <div>
                                    <h6 style={{ color: "#333", fontWeight: "600", marginBottom: "20px" }}>
                                        Transaction History
                                    </h6>
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th style={{ color: "#666", fontWeight: "600" }}>Field</th>
                                                    <th style={{ color: "#666", fontWeight: "600" }}>Value</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Created At</td>
                                                    <td>{formatDateTime(transaction.created_at)}</td>
                                                </tr>
                                                <tr>
                                                    <td>Updated At</td>
                                                    <td>{formatDateTime(transaction.updated_at)}</td>
                                                </tr>
                                                <tr>
                                                    <td>IPN Received</td>
                                                    <td>
                                                        <span style={{
                                                            padding: "2px 8px",
                                                            backgroundColor: transaction.ipn_received ? "#28a745" : "#dc3545",
                                                            color: "white",
                                                            borderRadius: "4px",
                                                            fontSize: "12px"
                                                        }}>
                                                            {transaction.ipn_received ? "Yes" : "No"}
                                                        </span>
                                                    </td>
                                                </tr>
                                                {transaction.paytech_response && (
                                                    <tr>
                                                        <td>PayTech Response</td>
                                                        <td>
                                                            <pre style={{ 
                                                                backgroundColor: "#f8f9fa", 
                                                                padding: "10px", 
                                                                borderRadius: "4px",
                                                                fontSize: "12px",
                                                                overflow: "auto"
                                                            }}>
                                                                {JSON.stringify(JSON.parse(transaction.paytech_response), null, 2)}
                                                            </pre>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Transaction;